import type { VoidFunctionComponent } from 'react';

import Button from '../../../generic/Button';
import FormGroup from '../../../generic/Forms/FormGroup';
import LabeledTextInput from '../../../generic/Forms/LabeledTextInput';
import type { CustomLicenseScan } from '../../../../../shared/settings/customLicenseScans';

type Props = Pick<CustomLicenseScan, 'name' | 'matchCriteria'> & {
  index: number;
  onRemove: (index: number) => void;
  onUpdateName: (name: string) => void;
  onUpdateMatchCriteria: (matchCriteria: string) => void;
};

/**
 * CustomLicenseScanConfigRow represents a single custom license config row.
 */
const CustomLicenseScanConfigRow: VoidFunctionComponent<Props> = ({
  name,
  matchCriteria,
  index,
  onUpdateName,
  onUpdateMatchCriteria,
  onRemove,
}) => (
  <div className="margin-bottom-sm">
    <FormGroup direction="row" spacing="sm">
      <LabeledTextInput
        labelVariant="legacy"
        label="Name"
        value={name}
        size="small"
        onChange={onUpdateName}
        placeholder="My custom scan name"
      />
      <LabeledTextInput
        labelVariant="legacy"
        label="Match criteria"
        value={matchCriteria}
        size="small"
        onChange={onUpdateMatchCriteria}
        placeholder="eg: ^babel+"
      />
      {/* Note: this is a hack (because FormGroup doesn't let you control flex alignment) */}
      <div className="padding-top-xl">
        <Button
          type="error"
          size="small"
          onClick={() => onRemove(index)}
        >
          Remove
        </Button>
      </div>
    </FormGroup>
  </div>
);

export default CustomLicenseScanConfigRow;
